<template>
  <div class="smeClassificationInformation-main">
    <div class="first-part">
      <b-container class="text-left smeClassificationInformation-box">
        <b-row class="align-items-center">
          <b-col cols="12" class="d-sm-none mb-4">
            <div>
              <b-img src="@/assets/img/phone.svg" fluid alt="Responsive image"></b-img>
            </div>
          </b-col>
          <b-col cols="12" lg="7">
            <h2 class="text-white mb-4">{{ title }}</h2>
            <p class="text-white pt-3" v-html="description"></p>
            <button type="button" name="button" class="btn btn-primary mt-3 mb-5 kkvButton" @click="nextPage">
              {{ buttonText }}
            </button>
          </b-col>
          <b-col cols="12" lg="5" class="d-none d-sm-flex">
            <div>
              <b-img src="@/assets/img/phone.svg" fluid alt="Responsive image"></b-img>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SmeClassificationInformation',
  props: ['currentPage'],
  data() {
    return {
      title: 'Milyen besorolású az Ön vállalkozása?',
      description: `Tudja meg gyorsan és egyszerűen, hogy a cége mikro-, kis-, közép-, vagy nagyvállalkozásnak minősül.<br/>  
      Mérje fel, hogy mikro- kis-, vagy középvállalkozások, illetve nagyvállatok számára elérhető támogatásokkal, 
      pénzügyi eszközökkel érdemes-e terveznie cége fejlesztését.<br/>
      Lépjen tovább, hogy megismerje cége indikatív besorolását.`,
      buttonText: 'Tovább'
    }
  },
  computed: {
    ...mapGetters(['selectedUserCompany', 'isAuthenticated', 'selectedCompany'])
  },
  methods: {
    nextPage() {
      let companyId
      if (this.isAuthenticated) {
        companyId = this.selectedUserCompany.companyId
        if (this.currentPage == 'Favourites') {
          this.$router.push({ path: 'kkv-qualifier', query: { companyId: companyId } })
          return
        }
        if (!companyId) {
          this.$router.push('kkv-result')
        } else {
          this.$router.push({ path: 'kkv-result', query: { companyId: companyId } })
        }
      } else {
        companyId = this.selectedCompany.flaggerId
        this.$router.push({ path: 'kkv-qualifier', query: { companyId: companyId } })
        return
      }
    }
  }
}
</script>

<style scoped>
.smeClassificationInformation-main {
  background-color: white;
  margin-bottom: -20px;
}
.first-part {
  background-color: #00903c;
  border-top-left-radius: 100px;
  min-height: 536px;
}
.smeClassificationInformation-box {
  padding-top: 50px;
}
.kkvButton {
  background-color: white;
  color: #00903c;
  width: 270px;
  border: 2px solid;
}
.kkvButton:hover {
  background-color: var(--color-gray-02) !important;
  border-color: var(--color-gray-02) !important;
}

@media (max-width: 768px) {
  .title {
    font-size: 26px;
    line-height: 30px;
  }
  .description {
    font-size: 14px;
    line-height: 21px;
  }
  .kkvButton {
    width: 100%;
  }
  .first-part {
    min-height: 635px;
  }
}
</style>
